<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {

  }
</script>

<style lang="scss">
  @import '@/styles/_fonts.scss';
  html,body{
        font-family: 'BMWTypeNextTT';
        font-size: 12px;
        color: $black;
  }
</style>
